import { InjectionToken } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { IPortalLink } from './portal-link.type';

/**
 * The application the shell is currently showing, provided by
 * `NHAApplicationContainerModule.forRoot()`.
 *
 * A real token rather than the string `'CURRENT_APPLICATION'` it replaces: a string token has no type,
 * so every consumer had to assert its way past `inject` with `as any` and would have found out at
 * runtime if the provided shape ever changed. Lives here beside `IPortalLink` because the two consumers
 * — the application container and the client-exception logger — sit in different libraries and both
 * already depend on this one.
 */
export const CURRENT_APPLICATION = new InjectionToken<BehaviorSubject<IPortalLink>>('CURRENT_APPLICATION');
